// removed by extract-text-webpack-plugin
module.exports = {"InfoPanel":"InfoPanel__InfoPanel___2FZLW","SearchCount":"InfoPanel__SearchCount___2vHRW"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/Search/InfoPanel/InfoPanel.scss
// module id = 744
// module chunks = 0